export default __webpack_public_path__ + "static/media/easyIcon.d565b6b7.svg";